import { useQuery } from '@apollo/client';
import classNames from 'classnames/bind';
import { LocationType, TLocation } from 'common/autocomplete/types';
import SearchEverywhere from '../popularCities/SearchEverywhere';
import Location from './Location';
import SEARCH_AIRPORTS from './airportAutocomplete.gql';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IData {
  airportAutocomplete: TLocation[];
}

interface IProps {
  forDeparture: boolean;
  query: string;
  closeModal: () => void;
}

const SearchResults = ({ forDeparture, query }: IProps) => {
  const { data, previousData } = useQuery<IData>(SEARCH_AIRPORTS, {
    variables: { airportOnly: false, query },
  });

  const cachedData = data || previousData;

  if (!cachedData) {
    return null;
  }

  const locations = cachedData.airportAutocomplete.filter(
    location => !(forDeparture && location.type === LocationType.COUNTRY),
  );

  return (
    <section className={cx('SearchResults')}>
      {locations?.length > 0 ? (
        <ul className={cx('result_list')}>
          <Location
            forDeparture={forDeparture}
            locations={locations}
            query={query}
          />
        </ul>
      ) : (
        <div className={cx('error')}>
          <div className={cx('noresult')}>
            <div className={cx('inner')}>
              <p className={cx('text')}>
                입력하신 명칭과 연관된
                <br />
                국가, 도시, 공항명이 없습니다.
              </p>
            </div>
          </div>
          {!forDeparture && (
            <div className={cx('sub')}>
              <SearchEverywhere isNoResult />
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default SearchResults;
